import React, { useState, useEffect } from "react";
import columns from "../../../columns/NewSymbol.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton.jsx";
import { GetAllSymbolApi } from "../../../api/request/settings/Symbol.js";
import { useNavigate } from 'react-router-dom';
import Eye from "../../../assets/Eye.jsx";
import { Spin } from "antd";
import { useSelector } from "react-redux";


export default function Symbol() {

    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);

    const getAllSymbol = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
            }
            setIsLoading(true);
            const { data } = await GetAllSymbolApi(new URLSearchParams(params)?.toString());
            if (data?.success) {

                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            actions: (<button type="button" onClick={() => navigate(`/symbol_detail/Name=${encodeURIComponent(item?.groupName)}`)}><Eye /></button>),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllSymbol();
    }, [page, pageSize]);

    return (
        <div>
            <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                <TableWithSkeleton columns={columns} data={data} loading={isLoading} hiddenColumns={isSalesManager ? ["Actions"] : []} />
                {/* <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} /> */}
            </div>
        </div>
    );
}


